import type { OrganizationSubscription } from "@arbeidsark/shared"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { Button } from "~/components"
import { Margin } from "~/ur-react-components"
import { useTranslate } from "~/ur-react-hooks"
import { format } from "~/utils/date-fns/format"
import { useOrganizationMembership } from "~/utils/hooks/useOrganizationMembership"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`

const Title = styled.h4`
  margin-top: 0;
  font-size: 18px;
  color: ${(props) => props.theme.colors.gray0};
`

const Price = styled.p`
  margin: 0;
  font-size: 21px;
  font-weight: 500;
  margin-bottom: 1rem;
`

const BilledAt = styled.p``

const Cancel = styled.button`
  ${(props) => props.theme.button.reset}
  color: ${(props) => props.theme.colors.gray60};

  &:hover {
    text-decoration: underline;
  }
`

export interface SubscriptionSchoolActiveProps {
  schoolSubscription: OrganizationSubscription
}

const SubscriptionSchoolActive: React.FC<SubscriptionSchoolActiveProps> = ({
  schoolSubscription,
}) => {
  const organizationMembership = useOrganizationMembership()!
  const formattedTrialEndDate = format(
    schoolSubscription.trialEnd ?? new Date(),
    "d. MMMM yyyy",
  )
  const translations = useTranslate({
    willBeBilledAt: [
      "subscription-school.active.will-be-billed-at",
      { date: formattedTrialEndDate },
    ],
    editBillingInfo: "subscription-school.active.edit-billing-info",
    cancel: "subscriptions.cancel-subscription",
  })

  return (
    <Layout>
      <Card>
        <Title>{organizationMembership.organization.name}</Title>
        <Price>{schoolSubscription.monthlyPrice * 12} kr</Price>
        <BilledAt>{translations.willBeBilledAt()}</BilledAt>
        <Margin bottom="1.5rem">
          <Link to="/settings?tab=billing">
            <Button>{translations.editBillingInfo}</Button>
          </Link>
        </Margin>
        <Link to="/subscription/school-cancel">
          <Cancel>{translations.cancel}</Cancel>
        </Link>
      </Card>
    </Layout>
  )
}

export default SubscriptionSchoolActive
